import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Box, Button, Heading, HStack, Spinner, Switch, Text, VStack } from '@chakra-ui/react'
import { useEventPrintPackets } from '../hooks/useLobbyDay'
import { AttendeePrintSection } from '../components/lobbyDay/print/AttendeePrintSection'
import type { AttendeeDeliveryMode } from '../types/lobbyDay'
import '../components/lobbyDay/print/lobby-print.css'

const PAPER: AttendeeDeliveryMode[] = ['Paper', 'Both']
const ALL: AttendeeDeliveryMode[] = ['App', 'Paper', 'Both']

export function LobbyPrintPacketsPage() {
  const { id } = useParams<{ id: string }>()
  const [includeApp, setIncludeApp] = useState(false)
  const { data, isLoading, error } = useEventPrintPackets(id, includeApp ? ALL : PAPER)

  if (isLoading) return <VStack py={12}><Spinner size="lg" color="accent" /></VStack>
  if (error) return <Text color="red.500">Failed to load packets.</Text>

  return (
    <Box className="lobby-print-root" p={6}>
      <HStack className="no-print" justify="space-between" mb={4} flexWrap="wrap" gap={3}>
        <Heading size="lg">{data?.eventName} — Packets</Heading>
        <HStack gap={4}>
          <Switch.Root checked={includeApp} onCheckedChange={(e) => setIncludeApp(e.checked)}>
            <Switch.HiddenInput />
            <Switch.Control>
              <Switch.Thumb />
            </Switch.Control>
            <Switch.Label>Include app attendees</Switch.Label>
          </Switch.Root>
          <Button colorPalette="brand" onClick={() => window.print()}>Print</Button>
        </HStack>
      </HStack>

      {data && data.attendees.length === 0
        ? <Text>No paper attendees yet — mark attendees as Paper on the Attendees tab.</Text>
        : data?.attendees.map((a) => <AttendeePrintSection key={a.attendeeId} attendee={a} />)}
    </Box>
  )
}
